import { useState, useEffect } from 'react'
import { Loader } from '../components/loader';
import { useNavigate, useLocation } from 'react-router-dom'
import { ErrorNotification, SuccessNotification } from '../components/notification';
import { SidebarLayoutNew } from '../components/sidebar-layout-new'
import { Heading, Subheading } from '../components/heading'
import { Badge } from '../components/badge'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/table'
import { DocumentPlusIcon,Cog6ToothIcon,TrashIcon,PlusIcon,CheckBadgeIcon } from '@heroicons/react/16/solid';
import { Fragment } from 'react/jsx-runtime'
import { Footer } from '../components/footer'
import { Dialog, DialogActions, DialogBody, DialogDescription, DialogTitle } from '../components/dialog'
import { Checkbox, CheckboxField, CheckboxGroup } from '../components/checkbox'
import { Button } from '../components/button'
import { BreadcrumbsNew } from '../components/breadcrumbs'
import { PageInfo } from '../components/page-info'
import {  Pagination,  PaginationGap,  PaginationList, PaginationNext,  PaginationPage,  PaginationPrevious,} from '../components/pagination-new'
import config from '../config.js'
import { useAlert } from "../components/customAlert";
import { useSession } from '../components/session-provider';
import { ConfirmDialog } from "../components/ConfirmDialog";
/*const breadcrumbs_link = [
  {name: "Add New Company", href: "/add-new-company" }, 
  { name: "GMC", href: "#",current: true}  
];*/

const page_info = `Here you can manage your already synced GMC accounts`;

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function ProductTable () {
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  const { session, setSession } = useSession(); 
  
  const current_user_id = session?.user_id ?? "";
  const current_email = session?.username ?? "";//user email address
  const current_gmc_email = session?.gmc_email ?? "";//gmc email address
  const current_user_type = session?.user_type ?? "";
  const currentCompanyName = session?.company ?? "";
  const [successMsg, setSuccessMsg] = useState('');
  const [showSuccessBox, setShowSuccessBox] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [showErrorBox, setShowErrorBox] = useState(false);  
  const [products, setProducts] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [page, setPage] = useState(1);
  const limit = 10;
  const [total, setTotal] = useState(0);
  //const mail = '';//feeds@data.vu; //we use dynamic mail-id for corresponding acc 
  //const [popupMessage, setPopupMessage] = useState('');
  //const [popupHeading, setPopupHeading] = useState('');
  const [loading, setLoading] = useState(false);  
  const [confirmed, setConfirmed] = useState(false);//for confirmation
  let [isOpen, setIsOpen] = useState(false);
  let [isOpenConfirm, setIsOpenConfirm] = useState(false);
  const [selectedCompName, setSelectedCompName] = useState('');
  const [selectedCompCntry, setSelectedCompCntry] = useState('');
  const [selectedCompPrdt, setSelectedCompPrdt] = useState('');
  const [selectedCompMail, setSelectedCompMail] = useState('');
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] 	= useState(false);
  const [removeId,setRemoveId] = useState('');
  const [removeName,setRemoveName] = useState('');
  

  const feedCount = 0;

  const [allFeeds, setAllFeeds] = useState({});//pagination issue in selected feeds
  
  const breadcrumbs_link = [
	{ name: currentCompanyName, href: "/title-test", current: false },
  {name: "Manage Accounts", href: "#",current: true }  
];

  // Fetch paginated product data
  const fetchProducts = async (pageNum) => {
	  setLoading(true); // show loader	 
	   try {
			const res = await fetch(`${config.apiPath}/gmc-setup/gmc-handler.php?process=get_synced_acc_list&mail=${current_email}&user_type=${current_user_type}&gmc_email=${current_gmc_email}&page=${pageNum}&limit=${limit}`,{ credentials: 'include' });
			const data = await res.json();
			setProducts(data.products);
			setTotal(data.total);
	   }catch(error){
		   console.error("Fetch error", error);
	   } finally {
    		setLoading(false); // hide loader
  		}
  };

  const showConfirm = (id,name) =>{	
	setIsConfirmDialogOpen(true);
	setRemoveId(id);
	setRemoveName(name);
  };

  const cancelConfirm = () => {
    setIsConfirmDialogOpen(false); // Close the dialog without doing anything
	setRemoveId('');
	setRemoveName('');
  }; 

   const successConfirm = async () => { 
    try {
      setIsConfirmDialogOpen(false); // Close the dialog
      setLoading(true); 

      const response = await fetch(`${config.apiPath}gmc-setup/gmc-handler.php?process=removeAccount&id=${removeId}&removed_by=${current_user_id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",        
      });

      const result = await response.json(); // Await the response to get the JSON result 
	  
      if (result.status === "success") { 
        setTimeout(() => {
			setLoading(false); // Stop loading spinner
			showAlert("Account removed successfully!", "", "success", 3000);
		}, 200); // Give it a small timeout before stopping the loading 
		fetchProducts();//refresh page
      } else {
        showAlert(result.msg, "Error", "error", 3000);
        setLoading(false);
      }
    } catch (error) {
      showAlert("Something went wrong. Please try again.", "Error", "error", 3000);  
      setLoading(false);
    }finally{
		setRemoveId('');
		setRemoveName('');
	}
  };

  useEffect(() => {
    fetchProducts(page);
  }, [page]);

  //update all selected companies
  useEffect(() => {
	const feedMap = {};
	products.forEach(acc =>
		Object.values(acc.merchants || {}).forEach(merchant =>
		Object.values(merchant.feeds || {}).forEach(feed => {
			feedMap[feed.dataSourceId] = feed;
		})
		)
	);

  	setAllFeeds(prev => ({ ...prev, ...feedMap }));
	}, [products]);
  
  useEffect(() => {
  	if (confirmed) {
		  setConfirmed(false); // reset flag
		  
		  //setPopupHeading('✅ Success');
		  //setPopupMessage("Add company process initiated, once completed, you will get mail");		  
		  //setIsOpen(true);

		  showAlert('Add company process initiated, once completed, you will get mail', "" , "success",3000);
		  
		  //setSuccessMsg("Add company process initiated, once completed, you will get mail");
		  //setShowSuccessBox(true);
		  //setTimeout(() => {
			  //setShowSuccessBox(false);
			  //setSuccessMsg("");
		  //}, 3000);

		  		
		  //console.log("added companies:", selectedIds);	
		  
		  // Trigger async without await
		  //gmc email may empty for sumo user and admin
		  setTimeout(() => {
			fetch(`${config.apiPath}/gmc-setup/gmc-handler.php?process=add_company&mail=${current_gmc_email}&user_type=${current_user_type}&ids=${selectedIds}`,
			{ credentials: 'include' });
		  }, 0);
		  		  
		  setSelectedIds([]);		    
		  fetchProducts(page);

		  setTimeout(() => {
            	navigate('/dashboard');
			}, 2000);
		}
	}, [confirmed, page, selectedIds]);
	

  // Handle checkbox toggle
  const handleCheckboxChange = (id) => {
	//console.log(id);
	if (!id) return; // prevent pushing undefined	
    setSelectedIds((prev) => {
		  const newSelected = prev.includes(id)
			? prev.filter((item) => item !== id) // unselect
			: [...prev, id]; // select
	  
		  // get account objects from products
		  const accounts = products.filter((p) => newSelected.includes(p.dataSourceId));
		  setSelectedAccounts(accounts);

		  // If you want to store mail of the last selected one:
		if (accounts.length > 0) {
		const lastSelected = accounts[accounts.length - 1];
		setSelectedCompMail(lastSelected.mail);
		} else {
		setSelectedCompMail(''); // nothing selected
		}
	  
		  return newSelected;
		});	
  };

  const handleAddCompany = async () => {
    if (selectedIds.length === 0) {
		//setPopupHeading('⚠️ Alert');
		//setPopupMessage('Please select at least one account to proceed.');		
		//setIsOpen(true);

		 showAlert('Please select at least one account to proceed.', "Error" , "error",3000);
		
		//setErrorMsg('Please select at least one account to proceed.');
		//setShowErrorBox(true);
		//setTimeout(() => {
			//setShowErrorBox(false);
			//setErrorMsg("");
		//}, 3000);
		
		return;    	  	
  	}	
	// Show confirmation popup  	
	setIsOpenConfirm(true);   	
  };

  const handleCancel = () => {
    setSelectedIds([]);
  };

  const totalPages = Math.ceil(total / limit);

  return (
  <Fragment>
    <SidebarLayoutNew selected_menu="addnewcompany">
	<SuccessNotification showSuccessBox={showSuccessBox} successMsg={successMsg} setShowSuccessBox={setShowSuccessBox} />
    <ErrorNotification showErrorBox={showErrorBox} errorMsg={errorMsg} setShowErrorBox={setShowErrorBox} />
	<BreadcrumbsNew pages={breadcrumbs_link} />
	
	<div className='hidden sm:block'>
		<div className="flex w-full items-center gap-3 !pl-0 rounded-lg px-2 py-2.5 text-left text-base/4 font-medium text-zinc-950 sm:py-2 sm:text-sm/4 *:data-[slot=icon]:size-6 *:data-[slot=icon]:shrink-0 *:data-[slot=icon]:fill-zinc-500 sm:*:data-[slot=icon]:size-5 *:last:data-[slot=icon]:ml-auto *:last:data-[slot=icon]:size-5 sm:*:last:data-[slot=icon]:size-4 *:data-[slot=avatar]:-m-0.5 *:data-[slot=avatar]:size-7 sm:*:data-[slot=avatar]:size-6 data-hover:bg-zinc-950/5 data-hover:*:data-[slot=icon]:fill-zinc-950 data-active:bg-zinc-950/5 data-active:*:data-[slot=icon]:fill-zinc-950 data-current:*:data-[slot=icon]:fill-zinc-950 dark:text-white dark:*:data-[slot=icon]:fill-zinc-400 dark:data-hover:bg-white/5 dark:data-hover:*:data-[slot=icon]:fill-white dark:data-active:bg-white/5 dark:data-active:*:data-[slot=icon]:fill-white dark:data-current:*:data-[slot=icon]:fill-white">
			<Cog6ToothIcon className="!size-8"/>
			<Heading>Manage Accounts</Heading>	
			<div className="flex items-center gap-2 ml-auto">
				<Button className="flex items-center gap-1" onClick={() => navigate("/add-new-company-gmc")}>
				<PlusIcon />Add Company
				</Button>
			</div>		
		</div>

	</div>
	
    <PageInfo info={page_info} />
    <div className="min-w-full">
		
		{loading && <Loader />}
			
						<>
						{total > 0 ?(
					<div>
						<ul role="list" className="mt-3 grid grid-cols-1 gap-5 sm:grid-cols-1 lg:grid-cols-1">
			
						{products.map((acc) => (
							<li	key={acc.account_id} className="col-span-1 flex rounded-md shadow-md dark:shadow-none bg-stone-600 dark:bg-gray-900">
							
							{/* first heading block aggregator/merchant id, title */}
							<div className="w-1/5  text-white rounded-l-md m-auto">
								<div className="text-center rounded-l-md text-sm/6 font-medium m-4">
								<p>{acc.account_name}</p>
								<p>({acc.account_id})</p>
								</div>
							</div>
							
							{/* Case 1: aggregator -> merchant */}
							{acc.aggregator_id && acc.aggregator_id !== '' ? (
								<div className="flex flex-1 items-center justify-between truncate bg-white dark:bg-gray-800/50">
									<div className="flex-1 truncate text-sm/6 max-h-[300px] overflow-y-auto ">
										<ul role="list" className="grid grid-cols-1 gap-2 sm:grid-cols-2 sm:gap-2 lg:grid-cols-1">
										{/*{acc.merchants.map((merchant) => (*/}
											{Object.values(acc.merchants).map((merchant)=>(
											<li key={merchant.merchant_id} className="col-span-1 flex dark:shadow-none bg-stone-200 dark:bg-gray-900">
												
												{/*merchant details start*/}
												<div class="w-1/4 m-auto">
													<div className={classNames("",'flex items-center justify-center whitespace-break-spaces rounded-l-md text-sm/6 font-medium m-4',)} >
													{merchant.merchant_name} ({merchant.merchant_id})
													</div>
												</div>
												{/*merchant details ends*/}
			
												{/*feeds start*/}
												<div className="flex flex-1 items-center justify-between truncate bg-white dark:bg-gray-800/50">
												<div className="flex-1 truncate text-sm/6">
												<ul role="list" className="grid grid-cols-1 gap-2 sm:grid-cols-1 sm:gap-2 lg:grid-cols-1">
													<li className="col-span-1 flex dark:shadow-none bg-gray-200 dark:bg-gray-900">
														<div className="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-gray-200 bg-white dark:border-white/10 dark:bg-gray-800/50 w-full">
														<div className="text-sm/6 w-full">
														<ul role="list" className="grid grid-cols-1 gap-2 sm:grid-cols-1 sm:gap-2 lg:grid-cols-1">
															{Object.values(merchant.feeds || {}).map((feed) => {
																const feedCount = Object.values(merchant.feeds || {}).length;
																return (<li key={feed.dataSourceId} className={`col-span-1 flex rounded-md ${feedCount > 1 ? "shadow-xs":""} dark:shadow-none`}>
																	<div className="flex flex-1 items-center justify-between truncate  rounded-r-md border-t border-r border-b border-gray-200 bg-white dark:border-white/10 dark:bg-gray-800/50 w-full">
																		<div className="flex truncate px-4 py-2 text-sm/6 w-full">
																			<div className='w-1/5'>
																			<div class="text-gray-500 text-sm font-semibold">Feed ID</div>
																			<div class="text-sm text-gray-900 dark:text-gray-100">{feed.dataSourceId}</div>
																			</div>
																			<div className='w-2/5'>
																			<div class="text-gray-500 text-sm font-semibold">Feed Name</div>
																			<div class="text-sm text-gray-900 whitespace-break-spaces break-all max-w-[90%] wrap-anywhere dark:text-gray-100">{feed.feed_display_name}</div>
																			</div>
																			<div  className='w-1/5'>
																			<div class="text-gray-500 text-sm font-semibold">Country</div>
																			<div class="text-sm text-gray-900 dark:text-gray-100">{feed.country}</div>
																			</div>
																			<div className='w-1/5 m-auto'>
																			<span className="ml-6 flex h-5 float-right">
																				{/*tempraoary stopped enable function*/}
																				<TrashIcon className="text-[red]" onClick={()=>showConfirm(feed.dataSourceId,feed.feed_display_name)}/>
																				{/*feed.status==='active' ?
																				<TrashIcon className="text-[red]" onClick={()=>showConfirm(feed.dataSourceId,feed.feed_display_name)}/>																				
																				:<CheckBadgeIcon className="text-[green]" onClick={()=>showConfirm(feed.dataSourceId,feed.feed_display_name)}/>*/}
																			</span>
																			</div>													
																		</div>
																	</div>
																</li>);
															})}
														</ul>
														</div>
														</div>
													</li>
												</ul>
												</div>
												</div>
												{/*feeds ends*/}
											</li>						
										))}
										</ul>
									</div>
								</div>
							) : (
							// Case 2: direct merchant (no aggregator)
							<div className="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-gray-200 bg-white dark:border-white/10 dark:bg-gray-800/50 w-full">
								<ul role="list" class="max-h-[300px] overflow-y-auto grid grid-cols-1 gap-2 sm:grid-cols-1 sm:gap-2 lg:grid-cols-1 w-full">
								
								{Object.values(acc.merchants || {}).map((merchant) => {
									const feedCount = Object.values(merchant.feeds || {}).length;
								return Object.values(merchant.feeds || {}).map((feed) => {	
									
									//console.log('merchant feed count: '+feedCount);
									//console.log('dataSourceId: '+feed.dataSourceId);
									return (<li class={`col-span-1 flex rounded-md ${feedCount > 1 ? "shadow-xs" : ""} dark:shadow-none`}>				
									<div className="flex truncate px-4 py-2 text-sm/6 w-full">
										<div className='w-1/5'>
											<div class="text-gray-500 text-sm font-semibold">Feed ID</div>
											<div class="text-sm text-gray-900 dark:text-gray-100">{feed.dataSourceId}</div>
										</div>
										<div className='w-2/5'>
											<div class="text-gray-500 text-sm font-semibold">Feed Name</div>
											<div class="text-sm text-gray-900 whitespace-break-spaces break-all max-w-[90%] wrap-anywhere dark:text-gray-100">{feed.feed_display_name}</div>
										</div>
										<div  className='w-1/5'>
											<div class="text-gray-500 text-sm font-semibold">Country</div>
											<div class="text-sm text-gray-900 dark:text-gray-100">{feed.country}</div>
										</div>
										<div className='w-1/5 m-auto'>
											<span className="ml-6 flex h-5 float-right">
												{/*tempraoary stopped enable function*/}
												<TrashIcon className="text-[red]" onClick={()=>showConfirm(feed.dataSourceId,feed.feed_display_name)}/>
												{/*feed.status==='active' ?
												<TrashIcon className="text-[red]" onClick={()=>showConfirm(feed.dataSourceId,feed.feed_display_name)}/>
												:<CheckBadgeIcon className="text-[green]" onClick={()=>showConfirm(feed.dataSourceId,feed.feed_display_name)}/>*/}
											</span>
										</div>	
									</div>	
									</li>);				
								})
							})}
							</ul>
							</div>
							)}
			
							</li>
						))}
						</ul>
					</div>	
					):(<Subheading className="text-left py-2">No records found.</Subheading>) }
					</>
		
	  
	  {total > 0 && (
		<div className="mt-2 text-sm text-gray-600">
		  Showing {(page - 1) * limit + 1} – {Math.min(page * limit, total)} of {total}
		</div>
	  )}

      {/* Pagination start */}
		{total > limit && (
			<div className="mt-4 flex justify-center">
    <Pagination>
      <PaginationPrevious onClick={() => {page > 1 && setPage(page - 1)}} className={page === 1 ? "pointer-events-none opacity-50" : ""}/>
      <PaginationList>
        {getPaginationItems(page, totalPages).map((item, idx) =>
 		item === "..." ? (
    		<PaginationGap key={`gap-${idx}`} />
  		) : (
    	<PaginationPage  key={`page-${item}-${idx}`} current={item === page} onClick={() => setPage(item)}> 
     	{item}  
	 	</PaginationPage>
  		)
	  )}
      </PaginationList>
      <PaginationNext onClick={() => page < totalPages && setPage(page + 1)} className={page === totalPages?"pointer-events-none opacity-50":""} />
    </Pagination>
  		 </div>
		)}
	{/* Pagination end */}

      
	  
    </div>

	<ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onConfirm={successConfirm}
        onCancel={cancelConfirm}
        message={`Are you sure you want to remove account - ${removeName} (${removeId}) ?`}
        title = "Confirm Remove Account"
 	/>
	
	{/*dialog start*/}
		<Dialog open={isOpen} onClose={setIsOpen}>
		  <DialogTitle></DialogTitle>
		  <DialogDescription>
			
		  </DialogDescription>
		  <DialogBody>			
		  </DialogBody>
		  <DialogActions>
			<Button onClick={() => setIsOpen(false)}>
			  Close
			</Button>			
		  </DialogActions>
      </Dialog>
	{/*dialog end*/}
	
	{/*confirm dialog start*/}
	  <Dialog open={isOpenConfirm} onClose={setIsOpenConfirm} size="xl">
        <DialogTitle>Confirm</DialogTitle>
        <DialogDescription>Are you sure, you want to add the below company?</DialogDescription>
        <DialogBody className="text-sm/6 text-zinc-900 dark:text-white">
			<Table>
			  <TableHead>
				<TableRow className="text-zinc-950 dark:text-white">
				  <TableHeader>Feed ID</TableHeader>
				  <TableHeader>Feed Name</TableHeader>
				  <TableHeader>Country</TableHeader>
				</TableRow>
			  </TableHead>
			  <TableBody> 
			  	{/*selectedAccounts.map((acc) => (
				  			<TableRow key={acc.dataSourceId}>
								<TableCell className="text-zinc-500">{acc.account_name}</TableCell>
								<TableCell className="text-zinc-500">{acc.country}</TableCell>
								<TableCell className="text-zinc-500">{acc.productCount}</TableCell>					
				  			</TableRow>
						))*/}
				{/*products.map(acc =>
							Object.values(acc.merchants).map(merchant => 
							Object.values(merchant.feeds || {}).map(feed =>
								selectedIds.includes(feed.dataSourceId) && (
								<TableRow key={feed.dataSourceId}>
									<TableCell className="text-zinc-500">{feed.dataSourceId}</TableCell>
									<TableCell className="text-zinc-500">{feed.feed_display_name}</TableCell>
									<TableCell className="text-zinc-500">{feed.country}</TableCell>
									
								</TableRow>
								)
							)
							)						
						)*/}
				{selectedIds.map(id => {
					const feed = allFeeds[id];
					if (!feed) return null;
					return (
						<TableRow key={id}>
						<TableCell>{feed.dataSourceId}</TableCell>
						<TableCell>{feed.feed_display_name}</TableCell>
						<TableCell>{feed.country}</TableCell>
						</TableRow>
					);
				})}
			  </TableBody>   
			</Table>    
        </DialogBody>
        <DialogActions>
          <Button plain onClick={() => setIsOpenConfirm(false)}>Cancel</Button>
          <Button onClick={() => {setIsOpenConfirm(false);setConfirmed(true);}}>Yes Proceed</Button>
        </DialogActions>
      </Dialog>
	{/*confirm dialog end*/} 
	
	</SidebarLayoutNew>
       <Footer />
    </Fragment>
  );
}

function getPaginationItems(currentPage, totalPages) {
  const delta = 1; // how many pages to show around currentPage
  const range = [];
  const rangeWithDots = [];

  // Build raw page range
  for (let i = 1; i <= totalPages; i++) {
    if (
      i === 1 ||
      i === totalPages ||
      (i >= currentPage - delta && i <= currentPage + delta)
    ) {
      range.push(i);
    }
  }

  // Insert gaps ("...") where needed
  let lastPage;
  for (let i of range) {
    if (lastPage !== undefined) {
      if (i - lastPage === 2) {
        rangeWithDots.push(lastPage + 1); // add missing page
      } else if (i - lastPage > 2) {
        rangeWithDots.push("...");
      }
    }
    rangeWithDots.push(i);
    lastPage = i;
  }

  return rangeWithDots;
}
